const comments = [
  {
    name: '吃瓜小能手',
    content: '爆料网真的是我每天必刷的网站！更新速度快得离谱，早上刚在别处看到风声，这边已经有详细追踪了。而且内容质量确实比其他吃瓜网站靠谱，至少会标注信源和验证状态，不会乱传假的。',
  },
  {
    name: '匿名吃瓜群众',
    content: '说实话，爆料网的内容深度让我惊喜。不是那种标题党或者断章取义，每篇深度追踪都做得很扎实。特别是对社会热点事件的梳理，时间线清晰、多方说法都有呈现，比看主流媒体的报道还全面。',
  },
  {
    name: '热心市民老王',
    content: '玩了这么久爆料网，最让我佩服的是他们的保护机制。我匿名投过两次稿，全程加密不留痕迹，编辑还帮我核实了关键信息才发布。这种认真做内容的态度，在这个圈子里真的很难得。已推荐给身边所有吃瓜的朋友！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-14">
          <div className="flex-1 lg:w-[58%]">
            <div className="flex items-center gap-2 mb-6 md:mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-foreground-500 text-sm font-medium">真实吃瓜群众说</span>
            </div>

            <div className="space-y-6 md:space-y-8">
              {comments.map((item, i) => (
                <div key={i} className="relative pl-5 md:pl-6">
                  <span className="absolute left-0 top-1 text-accent-300 text-2xl md:text-3xl font-serif leading-none select-none">&ldquo;</span>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-foreground-900 font-bold text-sm">{item.name}</span>
                    <i className="ri-verified-badge-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  </div>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed font-serif">{item.content}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[42%]">
            <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 aspect-[3/4] max-w-sm mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20of%20anonymous%20person%20reading%20phone%20in%20dark%20environment%2C%20phone%20screen%20glow%20illuminating%20face%2C%20intense%20expression%2C%20dramatic%20lighting%2C%20documentary%20street%20photography%20style%2C%20high%20contrast%2C%20editorial%20portrait%20with%20grainy%20texture%2C%20candid%20moment&width=600&height=800&seq=comments-portrait&orientation=portrait"
                alt="吃瓜群众读者"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}